import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import moment from 'moment'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import messages from 'routes/App/Dashboard/translate'
import SelectList from 'components/common/SelectList'
import ArrayHelper from 'helpers/array'
import { openEventFormModal } from 'reducers/logbook/reducer'
import { fetchActiveSitesWithoutSiteType } from 'reducers/digitalLogbook/reducer'
import { setActiveDate } from 'reducers/slaMonitor/reducer'
import { setSiteContext } from 'reducers/profile/reducer'
import ProfileHelper from 'helpers/profile'

class FilterBar extends Component {
  componentDidMount() {
    this.props.fetchActiveSitesWithoutSiteType()
  }

  shouldComponentUpdate(nextProps) {
    if (
      this.props.siteList !== nextProps.siteList &&
      nextProps.siteList.size > 0
    ) {
      if (
        nextProps.activeSite === 0 ||
        (nextProps.activeSite !== 0 &&
          !ArrayHelper.hasInArray(
            nextProps.siteList.toArray(),
            nextProps.activeSite,
            'id',
          ))
      ) {
        const activeSite = nextProps.siteList.get(0)
        this.props.setSiteContext({ site: activeSite.id })

        return false
      }
    }

    return true
  }

  onSiteChange = value => {
    if (value) {
      const { siteList, activeSite, setSiteContext } = this.props

      if (activeSite !== value.index) {
        setSiteContext({ site: siteList.get(value.mapKey).id })
      }
    }
  }

  dateRangeChange = false

  onDateChange = value => {
    if (!this.dateRangeChange) {
      this.props.setActiveDate(moment(value))
      this.dateRangeChange = true
    } else {
      this.dateRangeChange = false
    }
  }

  render() {
    const {
      hideButton,
      siteList,
      activeSite,
      activeDate,
      intl: { formatMessage },
      openEventFormModal,
    } = this.props
    const locale = ProfileHelper.getCurrentLocale()

    return (
      <Grid container spacing={1}>
        <Grid item lg={3} md={4} sm={6} xs={12} className="avatar-block">
          <SelectList
            variant="outlined"
            name="site"
            label={formatMessage(messages.site_list)}
            onChange={this.onSiteChange}
            list={siteList}
            value={activeSite}
            map={{
              index: 'id',
              text: 'name',
            }}
          />
        </Grid>
        <Grid item lg={3} md={2} sm={3} xs={12} className="avatar-block">
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <DatePicker
              autoOk
              fullWidth
              disableToolbar
              disableFuture
              variant="inline"
              format="dd/MM/yyyy"
              id="date-picker-inline"
              label="DD-MM-YYYY"
              value={activeDate}
              onChange={this.onDateChange}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        {!hideButton && (
          <Grid item lg={6} md={6} sm={3} className="create-button-block">
            <Button
              className="create-event-btn"
              variant="contained"
              color="primary"
              type="button"
              size="medium"
              onClick={() =>
                openEventFormModal({ isOpen: true, type: 'create' })
              }>
              {formatMessage(messages.createEvent)}
            </Button>
          </Grid>
        )}
      </Grid>
    )
  }
}

export default connect(
  state => ({
    siteList: state.getIn(['digitalLogbook', 'siteList']),
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
  }),
  {
    fetchActiveSitesWithoutSiteType,
    setSiteContext,
    setActiveDate,
    openEventFormModal,
  },
)(injectIntl(FilterBar))
